export const REMEMBER_SECONDS = {
  easy: 5,
  hard: 2.5,
  brutal: 1.2,
}

export const SOUND_LISTEN_SECONDS = {
  easy: 2.2,
  hard: 1.2,
  brutal: 0.7,
}
